import React, { useState, useEffect } from 'react'
import { Stepper, Button, Group, TextInput, Radio, Title, Text, Select, Textarea, CloseButton, Notification, Tooltip, Modal } from '@mantine/core';
import { MdOutlineAlternateEmail, MdOutlinePhoneEnabled } from "react-icons/md";
import { Link, useNavigate } from 'react-router-dom';
import { GrDocumentText } from "react-icons/gr";
import UploadFile from '../../shared/UploadFile';
import { useSelector } from 'react-redux';
import { getData, postData, postFormData } from 'views/Website/services/fetch-service';
import { FaCheck, FaInfoCircle } from 'react-icons/fa';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import CopyToClipboard from 'react-copy-to-clipboard';
import { RxCross1 } from 'react-icons/rx';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const Tjeter = () => {
    const [active, setActive] = useState(0);
    const prevStep = () => setActive((current) => (current > 0 ? current - 1 : current));
    const [referenceTjera, setReferenceTjera] = useState();
    const [idTjera, setIdTjera] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const baseUrl = process.env.REACT_APP_BASEURL

    const institutionsData = useSelector((state) => state.WebsiteLanguage.data.Instuticionet);
    const WebsiteLanguage = useSelector((state) => state.WebsiteLanguage.data.language);
    const GeneralTranslations = useSelector((state) => state.WebsiteLanguage.data.GeneralTranslations);
    const ControlsTranslations = useSelector((state) => state.WebsiteLanguage.data.ControlsTranslations);
    const ContentTranslations = useSelector((state) => state.WebsiteLanguage.data.ContentTranslations);
    const ValidationTranslations = useSelector((state) => state.WebsiteLanguage.data.ValidationTranslations);
    const AlertTranslations = useSelector((state) => state.WebsiteLanguage.data.AlertTranslations);

    const handleCloseButtonClick = () => {
        setNotificationBox(null);
    }

    const getValidationSchema = (activeStep) => {
        if (activeStep === 0) {
            return Yup.object().shape({
                raportuesiEmri: Yup.string().when('raportuesiAnonim', {
                    is: "false",
                    then: Yup.string().required(ValidationTranslations.requiredField),
                    otherwise: Yup.string(),
                }),
                raportuesiMbiemri: Yup.string().when('raportuesiAnonim', {
                    is: "false",
                    then: Yup.string().required(ValidationTranslations.requiredField),
                    otherwise: Yup.string(),
                }),
                // raportuesiEmail: Yup.string()
                //     .email(ValidationTranslations.validEmail)
                //     .required(ValidationTranslations.requiredField),
                // ConfirmEmailRaportuesi: Yup.string()
                //     .email(ValidationTranslations.validEmail)
                //     .oneOf([Yup.ref('raportuesiEmail'), null], ValidationTranslations.confirmEmail)
                //     .required(ValidationTranslations.requiredField),
                raportuesiGjiniaId: Yup.string().required(ValidationTranslations.requiredField),
            });
        } else if (activeStep === 1) {
            return Yup.object().shape({
                institucioniId: Yup.string().required(ValidationTranslations.requiredField),
                institucioniTjera: Yup.string().when('institucioniId', {
                    is: '-1',
                    then: Yup.string().required(ValidationTranslations.requiredField),
                    otherwise: Yup.string(),
                }),
                pershkrimi: Yup.string().required(ValidationTranslations.requiredField),
            });
        }

        return Yup.object();
    };

    let nameLocale = '';
    let othersLocale = '';

    if (WebsiteLanguage === 'sq') {
        nameLocale = 'nameSq';
        othersLocale = 'Tjetër';
    } else if (WebsiteLanguage === 'en') {
        nameLocale = 'nameEn';
        othersLocale = 'Other';
    } else if (WebsiteLanguage === 'sr') {
        nameLocale = 'nameSr';
        othersLocale = 'Ostalo';
    } else {
        nameLocale = 'nameSq';
        othersLocale = 'Tjetër';
    };

    const institutionsDataWithStringValues = institutionsData.map(item => ({
        value: `${item.id}`,
        label: item[nameLocale],
    }));

    institutionsDataWithStringValues.push({
        value: '-1',
        label: othersLocale
    });

    const handlePopup = () => {
        navigate('/');
    };

    const handlePaste = (event) => {
        event.preventDefault();
        return false;
    };

    const formik = useFormik({
        initialValues: {
            raportuesiAnonim: 'false',
            raportuesiEmri: '',
            raportuesiMbiemri: '',
            raportuesiEmail: '',
            ConfrimEmailRaportuesi: '',
            raportuesiGjiniaId: '',


            institucioniId: '',
            institucioniTjera: '',
            pershkrimi: '',
        },
        validationSchema: getValidationSchema(active),
        onSubmit: (values) => {
            let controlInstitucioniId = values;
            if (values.institucioniId === '-1') {
                controlInstitucioniId = { ...values, institucioniId: null }
            }
            postTjera(controlInstitucioniId)
        },
    });

    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileError, setSelectedFileError] = useState(false);
    const [documentName, setDocumentName] = useState('');
    const [documentType, setDocumentType] = useState('');
    const [savedDocuments, setSavedDocuments] = useState([]);
    const [documentsModelOpen, setDocumentsModelOpen] = useState(false);
    const [deleteDocumentsIndex, setDeleteDocumentsIndex] = useState(null);
    const [checkMediaError, setCheckMediaError] = useState(false);

    const [NotificationBox, setNotificationBox] = useState(null);
    const [languageValue, setLanguageValue] = useState(1);

    useEffect(() => {
        const languageMap = {
            'sq': 1,
            'en': 2,
            'sr': 3
        };

        setLanguageValue(languageMap[WebsiteLanguage]);
    }, [WebsiteLanguage]);

    const handleFileChange = async (file) => {
        try {
            const lastDotIndex = file.name.lastIndexOf('.');
            const fileType = file.name.slice(lastDotIndex);

            const checkMedia = await getData(`Deklarimi/CheckMedia?size=${file.size}&format=${fileType}&webLang=${languageValue}`);

            if (checkMedia && checkMedia.status === 200) {
                setSelectedFile(file);
            } else {
                setCheckMediaError(true);
                setSelectedFileError(true);
                throw new Error('Error invalid file');
            }
        } catch (error) {
            setCheckMediaError(true);
            setSelectedFileError(true);
            setNotificationBox(
                <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                    {AlertTranslations.CheckMediaErrorAlert}
                </Notification>
            );
            setTimeout(() => {
                setNotificationBox(null);
                setCheckMediaError(false);
                setSelectedFileError(false);
            }, 5000);
            setSelectedFile(null);
        }
    };

    const handleSave = async () => {
        try {
            if (selectedFile && documentName) {
                const updatedFile = new Blob([selectedFile], { type: selectedFile.type });
                updatedFile.name = documentName + documentType;

                const newDocument = {
                    file: updatedFile,
                };

                setSavedDocuments((prevDocuments) => [...prevDocuments, newDocument]);
                setSelectedFile(null);
                setDocumentName('');
                setDocumentType('');
                setSelectedFileError(false);
            }
        } catch (error) {
            setSelectedFile(null);
            setDocumentName('');
            setDocumentType('');
            setSelectedFileError(false);

            if (error.response && error.response.data) {
                setNotificationBox(
                    <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                        {error.response.data[0].message}
                    </Notification>
                );
                setTimeout(() => {
                    setNotificationBox(null);
                }, 5000);
            }
        }
    };

    const postTjera = async (data) => {
        try {
            const newData = {
                ...data,
                Gjuha: WebsiteLanguage,
            }
            const tjeraResponse = await postFormData('OtherReports/CreateOtherReports', newData);
            if (tjeraResponse) {
                setIdTjera(tjeraResponse.data.raportimets[0].id)
                setReferenceTjera(tjeraResponse.data.raportimets[0].referenca)
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
            setNotificationBox(
                <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                    {AlertTranslations.notifyError}
                </Notification>
            );
            setTimeout(() => {
                setNotificationBox(null);
            }, 5000);
        }
    };

    const postTjeraMedia = async () => {

        try {
            const data = {
                Files: savedDocuments,
                RaportimiId: idTjera,
            };

            let formData = new FormData();
            data.Files.forEach((doc) => {
                formData.append('Files', doc.file, doc.file.name);
            });

            formData.append('RaportimiId', data.RaportimiId);
            formData.append('Publik', true);

            const tjeraResponseMedia = await postData('Deklarimi/InsertRaportimetMedia', formData);

            if (tjeraResponseMedia) {
                setIsLoading(false);
            }

        } catch (error) {
            setIsLoading(false);
            setNotificationBox(
                <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                    {AlertTranslations.notifyError}
                </Notification>
            );
            setTimeout(() => {
                setNotificationBox(null);
            }, 5000);
        }
    };

    useEffect(() => {
        if (idTjera && savedDocuments && savedDocuments.length > 0) {
            postTjeraMedia();
        }
    }, [idTjera, savedDocuments]);

    const handleNextStep = () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                if (active === 1) {
                    if (selectedFile && !savedDocuments.some((doc) => doc.file === selectedFile)) {
                        setSelectedFileError(true);
                        setNotificationBox(
                            <Notification icon={<RxCross1 />} color="red" onClose={handleCloseButtonClick}>
                                {AlertTranslations.notifyFileRequired}
                            </Notification>
                        );
                        setTimeout(() => {
                            setNotificationBox(null);
                        }, 3000);
                        return;
                    }

                    setIsLoading(true);
                    formik.handleSubmit();
                    setTimeout(() => {
                        setActive(2);
                    }, 3000);
                } else if (active < 2) {
                    setActive((current) => current + 1);
                }
            } else {
                const raportuesiEmailError = formik.errors.raportuesiEmail;
                if (raportuesiEmailError) {
                    formik.setErrors({
                        ...formik.errors,
                        ConfirmEmailRaportuesi: raportuesiEmailError,
                    });

                    formik.setTouched({
                        ...formik.touched,
                        ConfirmEmailRaportuesi: true,
                    });
                }

                formik.setTouched(
                    Object.keys(formik.values).reduce((acc, key) => {
                        acc[key] = true;
                        return acc;
                    }, {})
                );
            }
        });
    };


    const handleDelete = (index) => {
        setDeleteDocumentsIndex(index);
        setDocumentsModelOpen(true);
    };

    const confirmDeleteDocuments = () => {
        if (deleteDocumentsIndex !== null) {
            const updatedDocuments = [...savedDocuments];
            updatedDocuments.splice(deleteDocumentsIndex, 1);
            setSavedDocuments(updatedDocuments);
        }
        closeModalDocuments();
    };

    const closeModalDocuments = () => {
        setDocumentsModelOpen(false);
        setDeleteDocumentsIndex(null);
    };

    useEffect(() => {
        if (selectedFile) {
            const lastDotIndex = selectedFile.name.lastIndexOf('.');
            const nameWithoutExtension = selectedFile.name.slice(0, lastDotIndex);
            const fileType = selectedFile.name.slice(lastDotIndex);
            setDocumentName(nameWithoutExtension);
            setDocumentType(fileType);
        }
    }, [selectedFile])

    const clearInputValue = () => {
        setDocumentName('');
        setDocumentType('');
        setSelectedFile(null);
        setSelectedFileError(false);
    };

    const maxChars = 2500;

    return (
        <div className="apk-home">
            <div className="stepper-container">
                <div className="stepper-header">
                    <Stepper allowNextStepsSelect={false} color="#051A53" active={active} onStepClick={setActive}>
                        <Stepper.Step label={ContentTranslations.step1Name} description={ContentTranslations.step1TjeraDescription}>
                            <div className="form-container">
                                <div className="form-section">
                                    <Title className="form-title" order={2}>
                                        <div className='icone'>
                                            {GeneralTranslations.Other}
                                            <Tooltip
                                                multiline
                                                sx={{ maxWidth: 500 }}
                                                position="top"
                                                className="tooltip-konflikt"
                                                withArrow arrowSize={8} label={AlertTranslations.OtherTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle size="18px" />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </Title>
                                    <Text className="form-desc" size="lg">
                                        <div className='icone'>
                                            {GeneralTranslations.step1TjeraSubTitle}
                                            <Tooltip withArrow arrowSize={8} label={AlertTranslations.OtherDataTooltip} color="#051A53">
                                                <div className="icone2">
                                                    <FaInfoCircle size="18px" />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </Text>
                                </div>

                                <Radio.Group
                                    name="raportuesiAnonim"
                                    label={GeneralTranslations.anonymous}
                                    value={formik.values.raportuesiAnonim}
                                    onChange={(value) => formik.setFieldValue('raportuesiAnonim', value)}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.raportuesiAnonim && formik.errors.raportuesiAnonim}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                >
                                    <Group mt="xs">
                                        <Radio color="#051A53" value="false" label={ControlsTranslations.no} />
                                        <Radio color="#051A53" value="true" label={ControlsTranslations.yes} />
                                    </Group>
                                </Radio.Group>
                                <Group grow className="name-group">
                                    <TextInput
                                        label={GeneralTranslations.name}
                                        placeholder={GeneralTranslations.name}
                                        name='raportuesiEmri'
                                        required={formik.values.raportuesiAnonim === "false" ? true : false}
                                        onChange={formik.handleChange}
                                        value={formik.values.raportuesiEmri}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.raportuesiEmri && formik.errors.raportuesiEmri}
                                        inputWrapperOrder={['label', 'error', 'input']}
                                    />
                                    <TextInput
                                        label={GeneralTranslations.lastName}
                                        placeholder={GeneralTranslations.lastName}
                                        name='raportuesiMbiemri'
                                        required={formik.values.raportuesiAnonim === "false" ? true : false}
                                        onChange={formik.handleChange}
                                        value={formik.values.raportuesiMbiemri}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.raportuesiMbiemri && formik.errors.raportuesiMbiemri}
                                        inputWrapperOrder={['label', 'error', 'input']}
                                    />
                                </Group>
                                <TextInput
                                    label={GeneralTranslations.numriTelefonit}
                                    placeholder={GeneralTranslations.numriTelefonit}
                                    leftSectionPointerEvents="none"
                                    type="tel"
                                    name='raportuesiNrTel'
                                    onChange={(e) => formik.setFieldValue('raportuesiNrTel', e.target.value)}
                                    value={formik.values.raportuesiNrTel}
                                    leftSection={<MdOutlinePhoneEnabled />}
                                />
                                <TextInput
                                    leftSectionPointerEvents="none"
                                    leftSection={<MdOutlineAlternateEmail />}
                                    label={GeneralTranslations.emailAddress}
                                    // required
                                    name='raportuesiEmail'
                                    placeholder={GeneralTranslations.emailAddress}
                                    onChange={formik.handleChange}
                                    value={formik.values.raportuesiEmail}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.raportuesiEmail && formik.errors.raportuesiEmail}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                />
                                <TextInput
                                    leftSectionPointerEvents="none"
                                    leftSection={<MdOutlineAlternateEmail />}
                                    label={ContentTranslations.ConfirmEmail}
                                    // required
                                    name='ConfirmEmailRaportuesi'
                                    onChange={formik.handleChange}
                                    onPaste={handlePaste}
                                    value={formik.values.ConfirmEmailRaportuesi}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.raportuesiEmail && formik.errors.ConfirmEmailRaportuesi}
                                    placeholder={ContentTranslations.ConfirmEmail}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                />
                                <Radio.Group
                                    label={GeneralTranslations.gender}
                                    name='raportuesiGjiniaId'
                                    withAsterisk
                                    value={formik.values.raportuesiGjiniaId}
                                    onChange={(value) => formik.setFieldValue('raportuesiGjiniaId', value)}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.raportuesiGjiniaId && formik.errors.raportuesiGjiniaId}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                >
                                    <Group mt="xs">
                                        <Radio color="#051A53" value="1" label="M" />
                                        <Radio color="#051A53" value="2" label="F" />
                                    </Group>
                                </Radio.Group>
                            </div>
                        </Stepper.Step>
                        <Stepper.Step label={ContentTranslations.step2Name} description={GeneralTranslations.step2TjeraDescription}>
                            <div className="form-container">
                                <div className="form-section">
                                    <Title className="form-title" order={2}>{GeneralTranslations.next}</Title>
                                    <Text className="form-desc" size="lg">{GeneralTranslations.step2TjeraSubTitle}</Text>
                                </div>

                                <Select
                                    searchable
                                    // clearable
                                    required
                                    key={WebsiteLanguage}
                                    data={institutionsDataWithStringValues}
                                    label={GeneralTranslations.institutionLabel}
                                    placeholder={GeneralTranslations.institutionLabel}
                                    name='institucioniId'
                                    onChange={(selected) => {
                                        formik.setFieldValue('institucioniId', selected);
                                    }}
                                    value={formik.values.institucioniId || ''}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.institucioniId && formik.errors.institucioniId}
                                // inputWrapperOrder={['label', 'error', 'select']}
                                />
                                {formik.values.institucioniId === '-1' && (
                                    <TextInput
                                        label={GeneralTranslations.institutionName}
                                        required
                                        placeholder={GeneralTranslations.institutionName}
                                        name='institucioniTjera'
                                        onChange={formik.handleChange}
                                        value={formik.values.institucioniTjera}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.institucioniTjera && formik.errors.institucioniTjera}
                                        inputWrapperOrder={['label', 'error', 'input']}
                                    />
                                )}
                                <Textarea
                                    rows={6}
                                    label={GeneralTranslations.caseDescription}
                                    placeholder={GeneralTranslations.caseDescription}
                                    required
                                    name='pershkrimi'
                                    onChange={(e) => {
                                        if (e.target.value.length <= maxChars) {
                                            formik.handleChange(e);
                                        }
                                    }}
                                    value={formik.values.pershkrimi}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.pershkrimi && formik.errors.pershkrimi}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                />
                                <Text size="sm" color={formik.values.pershkrimi?.length === maxChars ? 'red' : 'gray'} style={{ marginTop: 4 }}>
                                    {formik.values.pershkrimi?.length}/{maxChars}
                                </Text>
                                <div className="form-section title-headings">
                                    <Text className="form-desc" size="lg">{GeneralTranslations.listDocument}</Text>
                                </div>
                                <Group mt="xs" className="doc-input-group">
                                    <UploadFile onFileChange={handleFileChange} />
                                    <Group>
                                        <TextInput
                                            leftSectionPointerEvents="none"
                                            leftSection={selectedFile ? <GrDocumentText /> : null}
                                            placeholder={GeneralTranslations.documentName}
                                            rightSection={
                                                selectedFile ? (
                                                    <CloseButton size="sm" variant="transparent" onClick={clearInputValue} />
                                                ) : null
                                            }
                                            className='doc-input'
                                            error={selectedFileError ? `${checkMediaError ? AlertTranslations.CheckMediaErrorAlert : AlertTranslations.notifyFileRequiredInput}` : ""}
                                            value={documentName}
                                            onChange={(e) => setDocumentName(e.target.value)}
                                        />
                                        {selectedFile &&
                                            <Button className="btn-add-doc form-btn btn-search-report" type="button" color="#051A53" onClick={handleSave}>{ControlsTranslations.Add}</Button>
                                        }
                                        <Tooltip withArrow arrowSize={8} label={AlertTranslations.MediaAllowedTooltip} color="#051A53">
                                            <div className="icone2">
                                                <FaInfoCircle size="18px" />
                                            </div>
                                        </Tooltip>
                                        {/* {selectedFile &&
                                            <ActionIcon color="#051A53" onClick={handleSave}><FaRegSave /></ActionIcon>
                                        } */}

                                    </Group>
                                </Group>
                                {savedDocuments.length > 0 && (
                                    <div className='document-list'>
                                        <Table sx={{ minWidth: 300 }} aria-label="simple table" className="table-raportimet">
                                            <TableHead>
                                                <TableRow className="header-table">
                                                    <TableCell className="header-th">{GeneralTranslations.numberTable}</TableCell>
                                                    <TableCell className="header-th">{GeneralTranslations.documentNameTable}</TableCell>
                                                    <TableCell className="header-th"></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {savedDocuments.map((doc, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell >{index + 1}</TableCell>
                                                        <TableCell >{doc.file.name}</TableCell>
                                                        <TableCell >  <Button size='xs' className="btn-clear-table" onClick={() => handleDelete(index)} >{ControlsTranslations.Delete}</Button></TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </div>
                                )}
                            </div>
                        </Stepper.Step>
                        <Stepper.Completed>
                            <div className="form-container">
                                <div className="form-section">
                                    <Title className="form-title" order={2}>{GeneralTranslations.next}</Title>
                                    <Text className="form-desc" size="lg">{GeneralTranslations.reportDetail}</Text>
                                </div>

                                <Select
                                    searchable
                                    // clearable
                                    required
                                    key={WebsiteLanguage}
                                    data={institutionsDataWithStringValues}
                                    label={GeneralTranslations.institutionLabel}
                                    placeholder={GeneralTranslations.institutionLabel}
                                    name='institucioniId'
                                    onChange={(selected) => {
                                        formik.setFieldValue('institucioniId', selected);
                                    }}
                                    value={formik.values.institucioniId || ''}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.institucioniId && formik.errors.institucioniId}
                                // inputWrapperOrder={['label', 'error', 'select']}
                                />
                                {formik.values.institucioniId === '-1' && (
                                    <TextInput
                                        label={GeneralTranslations.institutionName}
                                        required
                                        placeholder={GeneralTranslations.institutionName}
                                        name='institucioniTjera'
                                        onChange={formik.handleChange}
                                        value={formik.values.institucioniTjera}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.institucioniTjera && formik.errors.institucioniTjera}
                                        inputWrapperOrder={['label', 'error', 'input']}
                                    />
                                )}

                                <Textarea
                                    rows={6}
                                    label={GeneralTranslations.caseDescription}
                                    placeholder={GeneralTranslations.caseDescription}
                                    required
                                    name='pershkrimi'
                                    onChange={(e) => {
                                        if (e.target.value.length <= maxChars) {
                                            formik.handleChange(e);
                                        }
                                    }}
                                    value={formik.values.pershkrimi}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.pershkrimi && formik.errors.pershkrimi}
                                    inputWrapperOrder={['label', 'error', 'input']}
                                />
                                <Text size="sm" color={formik.values.pershkrimi?.length === maxChars ? 'red' : 'gray'} style={{ marginTop: 4 }}>
                                    {formik.values.pershkrimi?.length}/{maxChars}
                                </Text>
                                <div className="form-section title-headings">
                                    <Text className="form-desc" size="lg">{GeneralTranslations.listDocument}</Text>
                                </div>
                                <Group mt="xs" className="doc-input-group">
                                    <UploadFile onFileChange={handleFileChange} />
                                    <Group>
                                        <TextInput
                                            leftSectionPointerEvents="none"
                                            leftSection={selectedFile ? <GrDocumentText /> : null}
                                            placeholder={GeneralTranslations.documentName}
                                            rightSection={
                                                selectedFile ? (
                                                    <CloseButton size="sm" variant="transparent" onClick={clearInputValue} />
                                                ) : null
                                            }
                                            className='doc-input'
                                            error={selectedFileError ? `${checkMediaError ? AlertTranslations.CheckMediaErrorAlert : AlertTranslations.notifyFileRequiredInput}` : ""}
                                            // error={
                                            //     checkMediaError
                                            //         ? `${AlertTranslations.CheckMediaErrorAlert}`
                                            //         : selectedFileError
                                            //             ? `${AlertTranslations.notifyFileRequiredInput}`
                                            //             : ""
                                            // }
                                            value={documentName}
                                            onChange={(e) => setDocumentName(e.target.value)}
                                        />
                                        {selectedFile &&
                                            <Button className="btn-add-doc form-btn btn-search-report" type="button" color="#051A53" onClick={handleSave}>{ControlsTranslations.Add}</Button>
                                        }
                                        <Tooltip withArrow arrowSize={8} label={AlertTranslations.MediaAllowedTooltip} color="#051A53">
                                            <div className="icone2">
                                                <FaInfoCircle size="18px" />
                                            </div>
                                        </Tooltip>
                                        {/* {selectedFile &&
                                            <ActionIcon color="#051A53" onClick={handleSave}><FaRegSave /></ActionIcon>
                                        } */}

                                    </Group>
                                </Group>
                                {savedDocuments.length > 0 && (
                                    <div className='document-list'>
                                        <Table sx={{ minWidth: 300 }} aria-label="simple table" className="table-raportimet">
                                            <TableHead>
                                                <TableRow className="header-table">
                                                    <TableCell className="header-th">{GeneralTranslations.numberTable}</TableCell>
                                                    <TableCell className="header-th">{GeneralTranslations.documentNameTable}</TableCell>
                                                    <TableCell className="header-th"></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {savedDocuments.map((doc, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell >{index + 1}</TableCell>
                                                        <TableCell >{doc.file.name}</TableCell>
                                                        <TableCell >  <Button size='xs' className="btn-clear-table" onClick={() => handleDelete(index)} >{ControlsTranslations.Delete}</Button></TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </div>
                                )}
                            </div>
                        </Stepper.Completed>
                    </Stepper>
                    <div className="apk-form-background">
                        <div className='logo'> <img src="/img/logo/web/logo-gray.png" alt="Logo" /></div>
                    </div>
                    <Link className='back-btn' to="/">{GeneralTranslations.BackToHome}</Link>
                </div>


                <div className="stepper-footer">
                    <Group justify="end" mt="xl">
                        {active >= 1 &&
                            <Button type="button" className="form-btn-back btn-base" variant="default" onClick={prevStep}>{ControlsTranslations.BackButton2}</Button>
                        }
                        <Button
                            type="submit"
                            leftSection={active === 2 && <FaCheck />}
                            className="form-btn btn-base"
                            onClick={() => {
                                handleNextStep();
                            }}
                            disabled={isLoading}
                        >
                            {isLoading ? ControlsTranslations.generating : active === 2 ? ControlsTranslations.finished : active === 1 ? ControlsTranslations.Send : ControlsTranslations.continue}
                        </Button>
                    </Group>
                </div>
            </div>
            {active === 2 && referenceTjera &&
                <Modal
                    className="raport-modal"
                    opened={true}
                    centered
                    size="lg"
                    withCloseButton={false}
                    // onClose={close}
                    overlayProps={{
                        backgroundOpacity: 0.55,
                        blur: 3,
                    }}
                >
                    <div className="completed-step">
                        <div className="completed-box">
                            <div className="text-content">
                                <Title className="form-title" order={2}>{GeneralTranslations.succes}</Title>
                                <Text className="form-desc" size="md">
                                    {GeneralTranslations.subjectNumber}
                                    <CopyToClipboard text={referenceTjera}>
                                        <Text
                                            td="underline"
                                            span
                                            c="blue"
                                            inherit
                                        >
                                            {referenceTjera}
                                        </Text>
                                    </CopyToClipboard>
                                </Text>
                            </div>

                            <div className="completed-footer">
                                <Group justify="end">
                                    <Button className="form-btn-back btn-base">
                                        <a
                                            href={`${baseUrl}Reports/GetOtherReports?type=1&ReferencaRaportimit=${referenceTjera}&webLangId=${languageValue}`}
                                            target="_blank"
                                        >
                                            {ControlsTranslations.download}
                                        </a>
                                    </Button>
                                    <Button className="form-btn btn-base" variant="default" onClick={handlePopup}>{ControlsTranslations.finish}</Button>
                                </Group>

                            </div>

                        </div>
                    </div>
                </Modal>
            }
            <Modal
                className="raport-modal"
                opened={documentsModelOpen}
                centered
                size="lg"
                withCloseButton={false}
                onClose={closeModalDocuments}
                overlayProps={{
                    backgroundOpacity: 0.55,
                    blur: 3,
                }}
            >
                <div className="completed-step">
                    <div className="completed-box">
                        <div className="text-content">
                            <Title className="form-title flex items-center gap-2" order={2}><FaInfoCircle color='#051A53' />  {AlertTranslations.AreYouSure}</Title>
                            <Text className="form-desc" size="md">
                                {AlertTranslations.AreYouSureDescription}
                            </Text>
                        </div>
                        <div className="completed-footer">
                            <Group justify="end">
                                <Button className="form-btn-back btn-base" variant="outline" onClick={closeModalDocuments}>
                                    {ControlsTranslations.no}
                                </Button>
                                <Button className="form-btn btn-base" variant="default" color="red" onClick={confirmDeleteDocuments}>
                                    {ControlsTranslations.yes}
                                </Button>
                            </Group>

                        </div>
                    </div>
                </div>
            </Modal>
            <div className="notification-cm">
                {NotificationBox}
            </div>
        </div>
    )
}

export default Tjeter